import { useEffect, useState, type FormEvent } from 'react';
import { UserManagementPanel } from 'auth-sso-kit/client/index.js';
import { api } from '../api/client';

const CHAMPS: { key: string; label: string; aide?: string; type?: string }[] = [
  { key: 'tarif_defaut', label: 'Tarif par séance par défaut (CHF)', aide: 'Appliqué aux personnes sans réglage propre.', type: 'number' },
  { key: 'date_ouverture_defaut', label: 'Date d’ouverture par défaut', aide: 'Les séances comptent à partir de cette date pour les personnes sans import Excel.', type: 'date' },
  { key: 'seuil_alerte', label: 'Seuil d’alerte (CHF dus)', type: 'number' },
  { key: 'contrats_termines_mois', label: 'Contrats terminés visibles (mois)', type: 'number' },
  { key: 'mesure_sisp_libelle', label: 'Mesure retenue (nom commercial dans Éveil)' },
  { key: 'facture_prefixe', label: 'Préfixe des numéros de facture' },
  { key: 'emetteur_nom', label: 'Émetteur — nom' },
  { key: 'emetteur_adresse', label: 'Émetteur — adresse' },
  { key: 'emetteur_mention', label: 'Mention sur le relevé' },
];

export function AdminPage() {
  const [reglages, setReglages] = useState<Record<string, string>>({});
  const [ok, setOk] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => { api.getMeta().then((m) => setReglages(m.reglages)).catch(() => {}); }, []);

  const enregistrer = async (e: FormEvent) => {
    e.preventDefault();
    try {
      setReglages(await api.updateReglagesGlobaux(Object.fromEntries(CHAMPS.map((c) => [c.key, reglages[c.key] ?? '']))));
      setOk(true); setTimeout(() => setOk(false), 2000); setError(null);
    } catch (err) { setError(err instanceof Error ? err.message : 'Échec'); }
  };

  return (
    <div className="page">
      <div className="page-header"><div className="page-heading"><span className="page-title">Administration</span></div></div>

      <div className="two-column">
        <div className="panel">
          <div className="panel-header"><h3>Réglages</h3></div>
          <div className="panel-body">
            <form onSubmit={enregistrer}>
              {CHAMPS.map((c) => (
                <div className="form-group" key={c.key}>
                  <label className="form-label">{c.label}</label>
                  <input className="form-input" type={c.type ?? 'text'} step={c.type === 'number' ? '0.05' : undefined} value={reglages[c.key] ?? ''} onChange={(e) => setReglages({ ...reglages, [c.key]: e.target.value })} />
                  {c.aide && <div className="text-xs text-ink-3 mt-4">{c.aide}</div>}
                </div>
              ))}
              {error && <div className="badge badge-err mb-12">{error}</div>}
              <button className="btn btn-accent" type="submit">Enregistrer</button>
              {ok && <span className="badge badge-ok ml-8">Enregistré</span>}
            </form>
          </div>
        </div>
        <div>
          <h3 className="section-label mb-12">Comptes</h3>
          <UserManagementPanel />
        </div>
      </div>
    </div>
  );
}
